import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import i18n from 'Pods/Shared/I18n'

function UserProjectsReviewMeta({ author = '', createdAt, price = '', locale }) {
  const priceLabel =  i18n.t('profilePage.priceLabel', { ns: 'rails', lng: locale })

  return (
    <div className="review-meta">
      {author && (
        <span>By {author}</span>
      )}
      {price && (
        <span>{`${priceLabel}: ${price}`}</span>
      )}
      <span>{moment(createdAt).format('YYYY-MM-DD')}</span>
    </div>
  )
}

UserProjectsReviewMeta.propTypes = {
  author: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
  price: PropTypes.string,
}

export default UserProjectsReviewMeta
